export const homeTimeZone = 'Asia/Karachi';